import { render } from "./ModalRegional.vue?vue&type=template&id=34dac2ce&scoped=true"
import script from "./ModalRegional.vue?vue&type=script&lang=js"
export * from "./ModalRegional.vue?vue&type=script&lang=js"

import "./ModalRegional.vue?vue&type=style&index=0&id=34dac2ce&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dac2ce"]])

export default __exports__